<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit" class="custom-chat">
    <div
      class="body-content-overlay"
      :class="{
        show: shallShowActiveChatContactSidebar || mqShallShowLeftSidebar,
      }"
      @click="
        mqShallShowLeftSidebar = shallShowActiveChatContactSidebar = false
      "
    />

    <!-- Main Area -->
    <section class="chat-app-window">
      <!-- Start Chat Logo -->
      <div v-if="!activeRoom.roomId" class="start-chat-area">
        <div class="mb-1 start-chat-icon">
          <feather-icon icon="AirplayIcon" size="56" />
        </div>
        <h4
          class="sidebar-toggle start-chat-text d-lg-none"
          @click="startConversation"
        >
          {{ $t("general.startConversation") }}
        </h4>
        <h4 class="sidebar-toggle start-chat-text d-none d-lg-block">
          {{ $t("general.selectMessageToStartYourConversation") }}
        </h4>
      </div>

      <!-- Chat Content -->
      <div v-else class="active-chat" @keydown="keyCloseConversation">
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">
            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">
              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <b-avatar
                size="36"
                class="mr-1 cursor-pointer badge-minimal customer-profile"
                variant="light-primary"
                badge
                :badge-variant="activeRoom.isOnline ? 'success' : 'secondary'"
                @click.native="shallShowActiveChatContactSidebar = true"
              >
                <feather-icon icon="UsersIcon" size="22" />
              </b-avatar>
              <h6 class="mb-0">
                {{ activeRoom.nameMember }}
              </h6>
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
              <b-badge class="m-0 mr-50" :variant="getRoomStateVariant(room)">
                <feather-icon icon="AlertCircleIcon" />
                {{ $t(`chat.${room ? `joining` : `join`}`) }}
              </b-badge>
              <div
                v-if="
                  !activeRoom.operatorAssigned ||
                  activeRoom.operatorAssigned == userData.id ||
                  userData.roleNames.includes('Super Admin')
                "
                class="dropdown"
              >
                <!--Header Section-->
                <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="17"
                      class="align-middle text-body"
                    />
                  </template>

                  <!-- assign -->
                  <!-- <b-dropdown-item v-if="activeRoom.state == conversationStatus.open &&
                    !activeRoom.blockAt &&
                    !activeRoom.operatorAssigned &&
                    $can('manage', 'assign-chat')
                    " @click="assignOperator">
                    {{ $t("chat.assign") }}
                  </b-dropdown-item> -->

                  <!-- transfer Operator -->
                  <b-dropdown-item v-if="room" @click="assignOperator">
                    {{ $t("chat.transfer") }}
                  </b-dropdown-item>

                  <!-- transfer to other merchant -->
                  <!-- <b-dropdown-item v-if="!isTransfer &&
                    !activeRoom.transferredFrom &&
                    activeRoom.state == conversationStatus.open &&
                    !activeRoom.blockAt &&
                    (activeRoom.operatorAssigned == userData.id ||
                      userData.roleNames.includes('Super Admin'))
                    " @click="transferToOtherMerchant">
                    {{ $t("chat.transferToMerchant") }}
                  </b-dropdown-item> -->

                  <!-- <b-dropdown-item v-if="!isTransfer &&
                    activeRoom.state == conversationStatus.open &&
                    !activeRoom.blockAt &&
                    $can('manage', 'close-conversation') &&
                    (activeRoom.operatorAssigned == userData.id ||
                      userData.roleNames.includes('Super Admin'))
                    " @click="confirmResolve(conversationStatus.close)">
                    {{ $t("chat.markAsResolve") }}
                  </b-dropdown-item> -->
                  <b-dropdown-item
                    v-if="!room && $can('manage', 'close-conversation')"
                    @click="confirmOpen(activeRoom.roomId)"
                  >
                    {{ $t("button.joinConversation") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-else-if="room && $can('manage', 'close-conversation')"
                    @click="confirmLeave()"
                  >
                    {{ $t("button.leave") }}
                  </b-dropdown-item>

                  <!-- <b-dropdown-item v-if="activeRomo.state == conversationStatus.open &&
                    !activeRoom.blockAt &&
                    $can('manage', 'block-customer')
                    " @click="confirmBan()">
                    {{ $t("chat.banThisCustomer") }}
                  </b-dropdown-item> -->

                  <!-- <b-dropdown-item v-if="activeRoom.state == conversationStatus.open &&
                    activeRoom.blockAt &&
                    $can('manage', 'block-customer')
                    " @click="confirmUnban()">
                    {{ $t("chat.unbanThisCustomer") }}
                  </b-dropdown-item> -->
                </b-dropdown>
              </div>
              <!-- menu profile -->
              <feather-icon
                v-if="!mqShallShowRightSidebar"
                role="button"
                class="ml-1"
                size="16"
                icon="MenuIcon"
                @click="toggleRightSidebar"
              />
              <feather-icon
                v-else
                role="button"
                class="ml-1"
                size="16"
                icon="XIcon"
                @click="toggleRightSidebar"
              />
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <div class="messages-body">
          <div v-if="!connectionStatus" class="connection-status no-internet">
            <small>{{ $t("chat.noInternet") }}</small>
          </div>
          <div
            ref="refChatLogPS"
            class="user-chats scroll-area overflow-y"
            @click="onBodyClick"
            @scroll="handleScrollMessage"
            :class="{ 'pt-2': !connectionStatus }"
          >
            <div class="infinite-wrapper">
              <infinite-loading
                v-show="messages.length"
                ref="infiniteLoading_prev"
                direction="top"
                :identifier="activeRoom.roomId"
                @infinite="listMessage_prev"
              >
                <div slot="spinner">
                  <b-spinner label="Spinning" />
                </div>
                <div slot="no-more" />
                <div slot="no-results" />
              </infinite-loading>
            </div>
            <chat-message
              :key="chatBoxKey"
              :active-room="activeRoom"
              :messages="messages"
              :read-message="activeRoom.readMessage"
              :user-typing="userTyping"
              @retry="retrySendMessage"
              @open-profile="openProfile"
            />
            <div class="infinite-wrapper">
              <infinite-loading
                v-show="messages.length"
                ref="infiniteLoading_next"
                direction="bottom"
                :identifier="activeRoom.roomId"
                @infinite="listMessage_next"
              >
                <div slot="spinner">
                  <b-spinner label="Spinning" />
                </div>
                <div slot="no-more" />
                <div slot="no-results" />
              </infinite-loading>
            </div>
          </div>
          <div
            v-if="!hidePullDown"
            class="action-btn pull-down-btn btn-primary rounded-circle"
            @click="fetchLatest"
          >
            <feather-icon icon="ArrowDownCircleIcon" size="40" />
          </div>
        </div>

        <!-- Message Input -->
        <chat-input
          v-if="room"
          ref="chatInput"
          :active-room="activeRoom"
          :toggle-right-sidebar="toggleRightSidebar"
          @send-text="sendTextMessage"
          @send-attachment="sendAttachmentMessage"
        />

        <div v-else class="chat-footer px-4">
          <div class="chat-app-form justify-content-center border-0">
            <b-button
              v-if="
                (!room || userData.roleNames.includes('Super Admin')) &&
                $can('manage', 'close-conversation')
              "
              variant="primary"
              block
              @click="confirmOpen(activeRoom.roomId)"
            >
              {{ $t("button.joinConversation") }}
            </b-button>
          </div>
        </div>
      </div>
    </section>
    <!--{{ userData }}-->
    <!-- Active Chat Contact Details Sidebar -->
    <chat-active-chat-content-details-sidedbar
      :shall-show-active-chat-contact-sidebar.sync="
        shallShowActiveChatContactSidebar
      "
      :contact="activeRoom || {}"
    />

    <!-- Sidebar :active-room="activeRoom" -->
    <portal to="content-renderer-sidebar-left">
      <chat-left-sidebar
        :identifier="identifier"
        :rooms="rooms"
        :active-room="activeRoom"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        :connection-status="connectionStatus"
        :loading="loading"
        @filter="filter"
        @open-chat="openRoom"
        @load-room="listRoom"
        @close-room="closeRoom"
      />
    </portal>
    <portal to="content-renderer-sidebar-right">
      <chat-right-sidebar
        ref="chatRightSidebar"
        :mq-shall-show-right-sidebar.sync="mqShallShowRightSidebar"
        :connection-status="connectionStatus"
        :send-text-message="changePreTextMessage"
        :active-room="activeRoom"
        :profile-id="profileId"
      />
    </portal>
    <assign-operator-modal
      ref="assignOperatorModal"
      :active-room="activeRoom"
      @reloadList="reloadList()"
    />
    <assign-merchant-modal
      ref="assignMerchantModal"
      :active-channel="activeRoom"
      @reloadList="reloadList()"
    />
    <load-profile />
  </div>
</template>

<script>
import store from "@/store";
import { ref } from "@vue/composition-api";
import {
  BAvatar,
  BDropdown,
  BDropdownItem,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
  BBadge,
  BSpinner,
  BImg,
  BDropdownDivider,
  BDropdownForm,
  BFormGroup,
  BInputGroupPrepend,
} from "bootstrap-vue";

import { $themeBreakpoints } from "@themeConfig";
import { useResponsiveAppSidebarVisibility } from "@core/comp-functions/ui/app";
import ChatRightSidebar from "@/components/global-components/PrivateChatRightSidebar.vue";
import Repository from "@/repositories/RepositoryFactory";
import conversationStatus from "@/data/conversationStatus";
import messageType from "@/data/messageType";
import messageStatus from "@/data/messageStatus";
import languageEn from "@/data/languages/en";
import languageKm from "@/data/languages/km";
import languageZh from "@/data/languages/zh-cn";
import languageVi from "@/data/languages/vi";
import { getCountryByLanguageCode } from "@/libs/helper";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import InfiniteLoading from "vue-infinite-loading";
import {
  connectSocketChatMeRoom,
  connectSocketChatMeMessage,
} from "@/libs/socket";
import Client from "@/repositories/Clients/AxiosClient";
import VueSweetalert2 from "vue-sweetalert2";
import localeCountries from "@/data/localeCountries";
import useJwt from "@/auth/jwt/useJwt";
import AssignOperatorModal from "./AssignOperatorModal.vue";
import AssignMerchantModal from "./AssignMerchantModal.vue";
import ChatInput from "./ChatInput.vue";
import ChatMessage from "./ChatMessage.vue";
import ChatActiveChatContentDetailsSidedbar from "./ChatActiveChatContentDetailsSidedbar.vue";
import ChatLeftSidebar from "./ChatLeftSidebar.vue";
import { defineFileType } from "../../helpers/fileHelper";
import chatPartnerSidebar from "@/navigation/vertical/menu/chatPartner";
import useChatPartnerStore from "@/store-pinia/useChatPartnerStore";
import _ from "lodash";

const ChatMeRoomRepository = Repository.get("chatMeRoom");
const ChatMessageRepository = Repository.get("chatMessage");
const PartnersShipRepository = Repository.get("partnersShip");

export default {
  components: {
    // BSV
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    BBadge,
    BSpinner,
    BImg,
    BDropdownDivider,
    BDropdownForm,
    BFormGroup,
    BInputGroupPrepend,

    // 3rd Party
    InfiniteLoading,
    VueSweetalert2,

    // SFC
    ChatLeftSidebar,
    ChatRightSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ChatMessage,
    ChatInput,
    AssignOperatorModal,
    AssignMerchantModal,
  },
  data() {
    return {
      sizeScroll: 0,
      filterRoom: {
        searchKeyWord: null,
        searchMsgType: "r",
        joinedRoomOnly: false,
        merchantRoomIds: [],
      },
      identifier: 1,
      activeRoom: {},
      rooms: [],
      room: "",
      messages: [],
      message: "",
      roomPerPage: 6,
      roomPage: 1,
      messagePerPage: 15,
      messagePage: 1,
      messageOriginCount: 0,
      roomsOriginCount: {
        all: 0,
        request: 0,
        joinByMe: 0,
      },
      shallShowActiveChatContactSidebar: false,
      randomKey: null,

      conversationStatus,
      messageType,
      messageStatus,
      isModalOpen: false,
      show: false,
      isTranslationOn: null,
      chatBoxKey: 0,
      loading: false,
      hidePullDown: true,

      retryRoomIntervalId: null,
      retryMessageIntervalId: null,
      chatPartnerSidebar,
      profileId: null,
      userTyping: null,
      isConnectedToInternet: navigator?.onLine,
      isSendingMessage: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
    isTransfer() {
      // if (this.activeChannel.transferred) {
      //   const transferring = this.activeChannel.transferred.find(
      //     (e) => !e.endedAt
      //   );
      //   if (transferring) {
      //     return true;
      //   }
      // }
      // return false;
    },
    profilePicture() {
      if (this.$store.state.profile.profilePicture) {
        return this.$store.state.profile.profilePicture;
      }

      return this.userData.profilePicture;
    },
    detectedLanguage() {
      const data = this.getCountryByLanguageCode(
        this.currentLocale,
        this.activeRoom.detectedLanguage || this.$i18n.locale
      );
      if (data) {
        return data;
      }
      return null;
    },
    operatorLanguage() {
      return getCountryByLanguageCode(
        this.currentLocale,
        this.activeRoom.operatorLanguage
      );
    },
    currentLocale() {
      if (this.$i18n.locale === "km") {
        return this.languageKm;
      } else if (this.$i18n.locale === "en") {
        return this.languageEn;
      } else if (this.$i18n.locale === "vi") {
        return this.languageVi;
      }

      return this.languageZh;
    },
    connectionStatus() {
      return (
        this.chatPartnerStore.isConnectedChatMeRoom &&
        this.chatPartnerStore.isConnectedChatMeMessage &&
        this.isConnectedToInternet
      );
    },

    roomSocket() {
      return this.chatPartnerStore.roomSocket;
    },
    messageSocket() {
      return this.chatPartnerStore.messageSocket;
    },
    isCanConnectSocketChatMe() {
      return (
        this.chatPartnerStore.isConnectedChatMeRoom &&
        this.chatPartnerStore.isConnectedChatMeMessage
      );
    },
  },
  watch: {
    // "chatPartnerStore.isConnectedChatMeRoom": {
    //   handler(newValue, oldValue) {
    //     if (!newValue && !this.retryRoomIntervalId) {
    //       this.retryRoomIntervalId = setInterval(() => {
    //         if (this.isConnectedToInternet) {
    //           this.chatPartnerStore.getTokenAndDomain();
    //         }
    //       }, 3000);
    //     } else if (newValue && this.retryRoomIntervalId) {
    //       clearInterval(this.retryRoomIntervalId);
    //       this.retryRoomIntervalId = null;
    //     }
    //   },
    //   immediate: true,
    // },

    // "chatPartnerStore.isConnectedChatMeMessage": {
    //   handler(newValue, oldValue) {
    //     if (!newValue && !this.retryMessageIntervalId) {
    //       this.retryMessageIntervalId = setInterval(() => {
    //         if (this.isConnectedToInternet) {
    //           this.chatPartnerStore.getTokenAndDomain();
    //         }
    //       }, 5000);
    //     } else if (newValue && this.retryMessageIntervalId) {
    //       clearInterval(this.retryMessageIntervalId);
    //       this.retryMessageIntervalId = null;
    //     }
    //   },
    //   immediate: true,
    // },
    isCanConnectSocketChatMe: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.listenMessageSocket();
        } else {
          this.chatPartnerStore.offEvents();
        }
      },
      immediate: true,
    },
    activeRoom(newValue, oldValue) {
      if (newValue) {
        this.mqShallShowRightSidebar = false;
        this.hidePullDown = true;
      }
    },
    // messages: {
    //   handler (newVal, oldVal) {
    //       if(this.sizeScroll > 30 && oldVal.length != 0 && newVal.length){
    //         this.hidePullDown = false;
    //       }
    //   },
    //   deep: true
    // },
  },
  mounted() {
    window.addEventListener("focus", this.windowFocus);

    window.addEventListener("chatSettings", (event) => {
      const data = JSON.parse(localStorage.getItem("chatSettings"));
      this.isTranslationOn = data?.isTranslationOn || true;
    });

    window.addEventListener("chatSettings", (event) => {
      const data = JSON.parse(localStorage.getItem("chatSettings"));
      this.isTranslationOn = data?.isTranslationOn || true;
    });

    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      bvEvent.vueTarget.$refs["close-button"].setAttribute("tabIndex", "-1");
      bvEvent.vueTarget.$refs["ok-button"]?.focus();
    });
    window.addEventListener("keydown", this.keyCloseConversation);
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.windowFocus);
    window.removeEventListener("online", this.updateInternetStatus);
    window.removeEventListener("offline", this.updateInternetStatus);
    this.resetState();
    this.chatPartnerStore.eventListenMessage();
  },
  created() {
    window.addEventListener("storage", (evt) => {
      if (evt.key == "chatSettings" && evt.newValue == null) {
        if (localStorage.getItem("chatSettings") == null) {
          localStorage.setItem(
            "chatSettings",
            JSON.stringify(this.userData.chatSettings)
          );
        }
      }
    });
    if (localStorage.getItem("chatSettings") == null) {
      localStorage.setItem(
        "chatSettings",
        JSON.stringify(this.userData.chatSettings)
      );
    }

    this.randomKey = uuidv4();
    if (localStorage.getItem("tabKey") == null) {
      localStorage.setItem("tabKey", this.randomKey);
    }

    const self = this;
    window.addEventListener("beforeunload", () => {
      localStorage.removeItem("tabKey");
    });
    window.addEventListener("storage", (evt) => {
      if (evt.key == "tabKey" && evt.newValue == null) {
        if (localStorage.getItem("tabKey") == null) {
          localStorage.setItem("tabKey", self.randomKey);
        }
      }
    });

    window.addEventListener("online", this.updateInternetStatus);
    window.addEventListener("offline", this.updateInternetStatus);
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyCloseConversation);
  },
  methods: {
    resetState() {
      this.sizeScroll = 0;
      this.filterRoom = {
        searchKeyWord: null,
        searchMsgType: "r",
        joinedRoomOnly: false,
        merchantRoomIds: [],
      };
      this.identifier = 1;
      this.activeRoom = {};
      this.rooms = [];
      this.room = "";
      this.messages = [];
      this.message = "";
      this.roomPerPage = 6;
      this.roomPage = 1;
      this.messagePerPage = 15;
      this.messagePage = 1;
      this.messageOriginCount = 0;
      this.roomsOriginCount = {
        all: 0,
        request: 0,
        joinByMe: 0,
      };
      this.retryRoomIntervalId = null;
      this.retryMessageIntervalId = null;
      this.profileId = null;
      this.userTyping = null;
      this.isConnectedToInternet = navigator?.onLine;
    },
    updateInternetStatus() {
      this.isConnectedToInternet = navigator?.onLine;
      // if (this.isConnectedToInternet) this.chatPartnerStore.getTokenAndDomain();
    },
    openProfile(profileId) {
      const profileIds = this.activeRoom.meta;
      const profileIndex = profileIds.findIndex(
        (profile) => profile.id == profileId
      );
      if (profileIndex != -1) {
        this.$refs.chatRightSidebar.openProfile(profileIndex);
        this.profileId = profileId;
        this.mqShallShowRightSidebar = true;
      }
    },
    windowFocus() {
      this.updateInternetStatus();
    },
    updateQuerySting() {
      this.$router.replace({ query: this.query });
      this.$nextTick(() => {
        if (this.query.cache != "no") {
          store.commit("app/UPDATE_CHAT_QUERY", { ...this.query });
        }
      });
    },
    getCountryCode(language) {
      return this.localeCountries.find(
        (e) => e.language.toLowerCase() === language.toLowerCase()
      ).flag;
    },
    showAlert() {
      this.$swal.fire({
        text: this.$t("alert.pleaseOpenConversationFirst"),
        icon: "warning",
        confirmButtonText: this.$t("button.close"),
      });
    },
    changeDetectedLanguage(selectedLang) {
      return (this.activeRoom = {
        ...this.activeRoom,
        detectedLanguage: selectedLang.language,
      });
    },
    changePreTextMessage(text) {
      this.$refs.chatInput.text = text;
      this.$refs.chatInput.$refs.inputBox?.$el?.focus();
    },
    toggleRightSidebar() {
      this.mqShallShowRightSidebar = !this.mqShallShowRightSidebar;
      this.preTextMessage = "";
    },
    //messageSocket//Interact, when socket connected/comeback to internet.
    listenMessageSocket() {
      if (this.activeRoom) {
        this.reloadListMessage(this.activeRoom); //reload list message and room
      } else {
        this.reloadListRoomFromMessage(); //reload list room
      }
      this.chatPartnerStore.eventListenMessage(this.displayMessageOneCb); //register listen-event message:receiveMessage
      this.listenMessageTyping(); //register listen-event message:onTyping
    },
    displayMessageOneCb(data) {
      const { room: roomId, message } = data.data;
      if (roomId == this.activeRoom?.roomId) {
        this.notifySeenMessages(this.activeRoom);
      } else {
        this.reloadListRoomFromMessage();
        return;
      }

      if (
        message.message === "activity.group.left" &&
        message.args.leftBy.merchantUserId === this.userData.id
      ) {
        this.room = null;
      } else if (
        message.message === "activity.group.join" &&
        message.args.joinedBy.merchantUserId === this.userData.id
      ) {
        this.getRoomInfo(roomId);
      }

      const { meta, _id, createdAt, attachments, status } = message || {};
      // Find the index of the message in the messages array based on meta[{ref}]
      if (meta) {
        const index = this.messages.findIndex((element) => {
          return (
            Array.isArray(meta) &&
            meta.length > 0 &&
            element.ref === meta[0].ref
          );
        });

        if (index !== -1) {
          this.messages[index].id = _id;
          this.messages[index].createdAt = createdAt;
          this.messages[index].sentStatus = this.messageStatus.sent;
          this.messages[index].attachments = attachments;
          this.messages[index].status = status;
        }
      } else {
        // Handle new messages without meta[{ref}]
        this.messages.push({
          ...message,
        });
      }

      // this.$nextTick(() => {
      //   this.scrollToBottom();
      // });
    },

    listenMessageTyping() {
      this.messageSocket.on(
        "message:onTyping",
        _.debounce((data) => {
          this.userTyping = data?.data || null;
        }, 400)
      );
    },

    reloadListMessage(room) {
      this.messageSocket.emit(
        "message:getMessages",
        {
          query: {
            limit: this.messageOriginCount,
            page: 1,
          },
          body: {
            roomId: room.roomId,
          },
        },
        (ackData) => {
          const messageOrigin = ackData.data || [];

          this.messages = messageOrigin.filter(
            (message) => message?.message != "activity.group.create"
          );
        }
      );

      this.notifySeenMessages(room);
    },
    toUtc(dateStr, hours = 0) {
      const date = new Date(dateStr);
      if (hours > 0) {
        date.setHours(date.getHours() + hours);
      }
      const utcDate = new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds()
        )
      );
      return utcDate;
    },

    addHours(dateStr, hours = 0) {
      const date = new Date(dateStr);
      if (hours > 0) {
        date.setHours(date.getHours() + hours);
      }
      return date;
    },

    async filter(query) {
      this.loading = true;
      let isLoadQuery = true;
      this.roomPage = 1;
      // this.roomPerPage = 6;
      this.roomsOriginCount.all = 0;
      this.roomsOriginCount.request = 0;
      this.roomsOriginCount.joinByMe = 0;
      this.filterRoom.joinedRoomOnly = false;

      if (query.filter == "joinByMe") {
        this.filterRoom.joinedRoomOnly = true;
      } else if (query.filter == "request") {
        const roomIds = await this.fetchRequestRoomIds();
        const merchantRoomIds = roomIds.map(({ chatMeRoomId }) => chatMeRoomId);

        if (merchantRoomIds.length >= 1) {
          this.filterRoom.merchantRoomIds = merchantRoomIds;
        } else {
          isLoadQuery = false;
          this.rooms = [];
        }
      }

      if (query.searchMsgType == "r") {
        this.rooms = [];
        const search = query.searchKeyWord ? query.searchKeyWord : null;
        if (search) {
          const searchTrim = search.trim();
          const response = await ChatMeRoomRepository.searchRoom({
            search: searchTrim,
          });
          const merchantRoomIds = response?.data?.data || []; //get id from purple chat
          this.filterRoom.merchantRoomIds = merchantRoomIds;
        } else if (query.filter != "request")
          this.filterRoom.merchantRoomIds = [];
      }

      if (isLoadQuery) this.identifier += 1;
      this.loading = false;
    },
    async listRoom($state = null) {
      this.loading = true;

      const queryCate = {
        searchKeyWord: this.$route.query.searchKeyWord || "",
        searchMsgType: this.$route.query.searchMsgType || "r",
        filter: this.$route.query.filter || "",
      };
      const query = { limit: this.roomPerPage, page: this.roomPage };

      if (queryCate?.filter == "request") {
        const roomIds = await this.fetchRequestRoomIds();
        const merchantRoomIds = roomIds.map(({ chatMeRoomId }) => chatMeRoomId);

        if (merchantRoomIds.length >= 1) {
          query["merchantRoomIds"] = merchantRoomIds;
        } else {
          this.rooms = [];
          if ($state) $state.complete();
          this.loading = false;
          return;
        }
      } else if (queryCate?.filter == "joinByMe") {
        query["joinedRoomOnly"] = true;
      }

      this.roomSocket.emit("room:getRooms", { query }, (ackData) => {
        this.roomPage += 1;
        const roomsOrigin = ackData.data || [];

        //count rooms before filter
        if (queryCate?.filter == "request") {
          this.roomsOriginCount.request += roomsOrigin.length;
        } else if (queryCate?.filter == "joinByMe") {
          this.roomsOriginCount.joinByMe += roomsOrigin.length;
        } else {
          this.roomsOriginCount.all += roomsOrigin.length;
        }

        //remove message = 'activity.group.create'
        const rooms = roomsOrigin.filter(
          (room) => room?.lastMessage?.message != "activity.group.create"
        );

        //rename group
        rooms.forEach((room) => {
          const otherUsers = room.meta.filter(
            (user) => user.id && user.id !== this.userData.id
          );
          room.nameMember = otherUsers.map((user) => user.name).join(" - ");
        });

        this.rooms = [...this.rooms, ...rooms];

        if ($state && roomsOrigin.length < this.roomPerPage) {
          $state.complete();
        }
        if ($state) $state.loaded();
        this.loading = false;
      });
    },
    async reloadListRoomFromMessage() {
      try {
        const queryCate = {
          searchKeyWord: this.$route.query.searchKeyWord || "",
          searchMsgType: this.$route.query.searchMsgType || "r",
          filter: this.$route.query.filter || "",
        };
        const query = { limit: this.roomPerPage, page: 1 };

        const roomIds = await this.fetchRequestRoomIds();
        const merchantRoomIds = roomIds.map(({ chatMeRoomId }) => chatMeRoomId);
        if (merchantRoomIds.length >= 1) {
          this.chatPartnerStore.countRoom.request = merchantRoomIds.length;
        } else {
          this.chatPartnerStore.countRoom.request = 0;
        }

        if (queryCate?.filter == "request") {
          if (merchantRoomIds.length >= 1) {
            query.limit = this.roomsOriginCount.request + 1;
            query["merchantRoomIds"] = merchantRoomIds;
          } else {
            this.rooms = [];
            this.chatPartnerStore.getCountMessage();
            return;
          }
        } else if (queryCate?.filter == "joinByMe") {
          query.limit = this.roomsOriginCount.joinByMe + 1;
          query["joinedRoomOnly"] = this.filterRoom.joinedRoomOnly;
        } else {
          query.limit = this.roomsOriginCount.all + 1;
        }

        this.roomSocket.emit("room:getRooms", { query }, (ackData) => {
          const roomsOrigin = ackData.data || [];

          const rooms = roomsOrigin.filter(
            (room) => room?.lastMessage?.message != "activity.group.create"
          );

          //rename group
          rooms.forEach((room) => {
            const otherUsers = room.meta.filter(
              (user) => user.id && user.id !== this.userData.id
            );
            room.nameMember = otherUsers.map((user) => user.name).join(" - ");
          });

          this.rooms = rooms;
        });
        this.$nextTick(() => {
          this.chatPartnerStore.getCountMessage();
        });
      } catch (error) {
        console.error("Error in reloadListRoomFromMessage:", error);
      }
    },
    async fetchRequestRoomIds() {
      try {
        const response = await ChatMeRoomRepository.getRequestJoin(); //get room id from purple chat
        const roomIds = response?.data?.data || [];
        return roomIds;
      } catch (error) {
        console.error("Error fetching get request join:", error);
        return [];
      }
    },
    closeRoom() {
      this.activeRoom = {};
    },
    keyCloseConversation(event) {
      if (!this.isModalOpen) {
        if (
          this.activeRoom.state == this.conversationStatus.open &&
          !this.activeRoom.blockAt &&
          this.activeRoom.operatorAssigned == this.userData.id
        ) {
          if (event.ctrlKey && event.key === "F2") {
            this.confirmResolve(this.conversationStatus.close);
          }
        }
      }
    },
    handleScrollMessage(e) {
      const el = e.target;
      const distance = el.scrollHeight - (el.scrollTop + el.offsetHeight);
      this.sizeScroll = distance;
      if (distance <= 30) {
        this.hidePullDown = true;
      } else if (this.hidePullDown) {
        this.hidePullDown = false;
      }
    },
    fetchLatest() {
      this.scrollToBottom("smooth");
      // Proceed when infinite scroll not yet done.
      if (this.$refs.infiniteLoading_next.status != 2) {
        // Needed to complete next scroll. Prevent unstop fetching.
        this.$refs.infiniteLoading_next.stateChanger.complete();
        // Fetch latest messages.
        this.listMessage();
      }
    },
    listMessage_prev($state) {
      const room = this.activeRoom;

      this.messageSocket.emit(
        "message:getMessages",
        {
          query: {
            limit: this.messagePerPage,
            page: this.messagePage,
          },
          body: {
            roomId: room.roomId,
          },
        },
        (ackData) => {
          this.messagePage += 1;

          const messageOrigin = ackData.data || [];
          this.messageOriginCount += messageOrigin.length;

          const filteredMessages = messageOrigin.filter(
            (message) => message?.message !== "activity.group.create"
          );

          this.messages.unshift(...filteredMessages);

          if ($state && ackData.data.length < this.messagePerPage) {
            $state.complete();
          }

          if ($state) {
            $state.loaded();
          }
        }
      );
    },
    listMessage_next($state) {
      const nextState = this.$refs.infiniteLoading_next.stateChanger;
      nextState.complete();
      this.scrollToBottom();
    },
    notifySeenMessages(room) {
      this.messageSocket.emit(
        "message:seenMessages",
        {
          body: {
            roomId: room.roomId,
          },
        },
        (ackData) => {
          this.reloadListRoomFromMessage();
        }
      );
    },
    listMessage($state = null) {
      const room = this.activeRoom;

      this.messageSocket.emit(
        "message:getMessages",
        {
          query: {
            limit: this.messagePerPage,
            page: this.messagePage,
          },
          body: {
            roomId: room.roomId,
          },
        },
        (ackData) => {
          this.messagePage += 1;

          const messageOrigin = ackData.data || [];
          this.messageOriginCount += messageOrigin.length;

          this.messages = messageOrigin.filter(
            (message) => message?.message != "activity.group.create"
          );

          const nextState = this.$refs.infiniteLoading_next.stateChanger;
          nextState.complete();
          nextState.reset();

          if ($state) $state.loaded();

          setTimeout(() => {
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }, 450);
        }
      );
    },
    openRoom(room) {
      this.messagePage = 1;

      this.activeRoom = room;
      this.mqShallShowLeftSidebar = false;
      this.messages = [];

      setTimeout(() => {
        this.$refs.infiniteLoading_prev.stateChanger.reset();
        this.$refs.infiniteLoading_next.stateChanger.reset();
      }, 150);

      this.listMessage(null);
      this.getRoomInfo(room.roomId);
      if (this.activeRoom.unreadCount >= 1) {
        this.notifySeenMessages(room);
      }
    },
    getRoomInfo(merchantRoomId) {
      ChatMeRoomRepository.getRoomInfo({ merchantRoomId }).then((response) => {
        this.room = response?.data?.data || null;
      });
    },
    async sendTextMessage(message, translate, roomId) {
      try {
        this.isSendingMessage = true
        if (!message) {
          return;
        }

        this.$refs.chatInput.typing(false);

        const data = {
          ref: uuidv4(),
          roomId: roomId,
          createdAt: moment(),
          type: "text",
          message,
        };

        console.log('sending message')

        await this.sendMessage(data);
      } finally {
        this.isSendingMessage = false
      }

    },
    sendAttachmentMessage(message, roomId) {
      if (!message.file) {
        return;
      }
      this.$refs.chatInput.typing(false);

      const fileType = defineFileType(message.file);

      const data = {
        ref: uuidv4(),
        createdAt: moment(),
        file: message.file,
        message: message.fileName,
        mediaUrl: message.fileUrl,
        roomId: roomId,
        type: fileType,
      };

      this.sendMessage(data);
    },

    async sendMessage(message) {
      try {
        this.isSendingMessage = true;
        const bodyMessage = {
          message: message.message,
          type: message.type, //"[message's type which is one of enum('text', 'media', 'file', 'link')] (required)",
          room: message.roomId,
          attachments: [],
          meta: [
            {
              ref: message.ref,
            },
          ],
        };

        const messageStatus = {
          ...message,
          type: message.type,
          room: message.roomId,
          sentStatus: this.messageStatus.sending,
          sender: {
            merchantUserId: this.userData.id,
          },
          ref: message.ref,
          createdAt: message.createdAt,
        };

        this.activeRoom = {
          ...this.activeRoom,
          lastMessage: {
            ...message,
            createdAt: message.createdAt,
          },
        };

        this.$nextTick(() => {
          if (this.$refs.infiniteLoading_next.status == 2) {
            this.scrollToBottom("smooth");
          }
        });

        if (!this.isCanConnectSocketChatMe) {
          messageStatus.sentStatus = this.messageStatus.fail;
          this.messages.push(messageStatus);
          return;
        }

        if (message.file) {
          const uploaded = await this.uploadImage(message);
          if (!uploaded) {
            messageStatus.sentStatus = this.messageStatus.fail;
            this.messages.push(messageStatus);
            return;
          }

          bodyMessage.attachments.push({
            url: uploaded.url,
            fileType: uploaded.fileType,
          });
        }

        this.messages.push(messageStatus); // push for display message in UI

        const newMessageBody = {
          body: bodyMessage,
        };

        this.messageSocket.emit(
          "message:sendMessage",
          newMessageBody,
          (ackData) => {
            console.log("Acknowledgement from openRoom:", ackData);
          }
        );
      } finally {
        setTimeout(() => {
          this.isSendingMessage = false;
        }, 500)
      }
    },
    retrySendMessage(index) {
      const message = this.messages[index];
      this.messages.splice(index, 1);
      this.sendMessage(message);
    },
    async uploadImage(message) {
      const formData = new FormData();
      formData.append("attachment", message.file);
      const response = await Client.post(
        `${this.chatPartnerStore.chatMeDomain}/attachment/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: this.chatPartnerStore.chatMeToken,
          },
          onUploadProgress: function (progressEvent) {
            const index = this.messages.findIndex(
              (element) => element.ref == message.ref
            );
            if (index != -1) {
              this.messages[index].uploadPercentage = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              );
            }
          }.bind(this),
        },
        {
          timeout: 0,
        }
      );

      const media = response?.data?.data;
      if (media) {
        return media;
      }
      const index = this.messages.findIndex(
        (element) => element.ref == message.ref
      );
      if (index != -1) {
        this.messages[index].sentStatus = messageStatus.fail;
      }
      return false;
    },

    getRoomStateVariant(room) {
      if (!room) {
        return "primary";
      }
      if (room) {
        return "success";
      }

      return "danger";
    },
    assignOperator() {
      this.$refs.assignOperatorModal.show(this.activeRoom.roomId, true);
    },
    transferToOtherMerchant() {
      const channelToken = this.activeRoom.token;
      PartnersShipRepository.show()
        .then((response) => {
          const { data } = response.data;
          const partnerShip = [...data.list];
          if (partnerShip && partnerShip.length >= 1) {
            this.$refs.assignMerchantModal.show(
              channelToken,
              !!this.activeRoom.operatorAssigned
            );
          } else {
            this.$swal.fire({
              text: this.$t("alert.pleaseAskAdminToBindAccount"),
              icon: "warning",
              confirmButtonText: this.$t("button.close"),
            });
          }
        })
        .catch();
    },
    confirmResolve(state) {
      this.isModalOpen = true;
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToResolve"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("chat.markAsResolve"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.updateStatus(state);
          } else {
            this.isModalOpen = false;
          }
        });
    },
    confirmOpen(roomId) {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToJoin"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("button.joinConversation"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.fetchLatest();
            this.updateStatus(roomId);
          }
        });
    },
    confirmBan() {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToBan"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("chat.banThisCustomer"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.block();
          }
        });
    },
    block() {
      const data = {
        token: this.activeRoom.token,
      };
      ChatChannelRepository.block(data)
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.activeRoom = {
              ...data,
            };
          }
        })
        .then((error) => {});
    },
    confirmLeave() {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToLeave"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("chat.leaveThisRoom"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.leaveRoom();
          }
        });
    },
    confirmUnban() {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToUnban"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("chat.unbanThisCustomer"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.unblock();
          }
        });
    },
    leaveRoom() {
      const data = {
        merchantRoomId: this.activeRoom.roomId,
      };

      ChatMeRoomRepository.leaveRoom(data)
        .then((response) => {
          const data = response?.data?.data;
          if (data && data.success) this.room = "";
        })
        .then((error) => {});
    },
    unblock() {
      const data = {
        token: this.activeRoom.token,
      };
      //ChatChannelRepository
      ChatChannelRepository.unblock(data)
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.activeRoom = {
              ...data,
            };
          }
        })
        .then((error) => {});
    },
    updateStatus(roomId) {
      const data = {
        merchantRoomId: roomId,
      };

      ChatMeRoomRepository.joinRoom(data)
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.room = data;
          }
        })
        .then((error) => {
          this.isModalOpen = false;
        });
    },
    autoAssignToOperator() {
      if (this.activeRoom.operatorAssigned) {
        return;
      }
      ChatChannelRepository.assign({
        token: this.activeRoom.token,
        userId: this.userData.id,
      })
        .then((response) => {
          this.hide();
          this.$emit("success");
        })
        .catch((error) => {
          if (error.response?.status == 422) {
            this.$refs.assignOperatorForm.setErrors(
              error.response?.data?.validate
            );
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    onBodyClick() {
      if (this.$refs.chatInput) {
        this.$refs.chatInput.closeEmoji();
      }
    },
  },
  setup() {
    const chatPartnerStore = useChatPartnerStore();

    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null);
    const scrollToBottom = (behavior = "instant") => {
      const scrollEl = refChatLogPS.value?.$el || refChatLogPS.value;
      scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior });
    };
    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar, mqShallShowRightSidebar } =
      useResponsiveAppSidebarVisibility();
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true;
      }
    };

    return {
      chatPartnerStore,
      refChatLogPS,
      scrollToBottom,
      languageEn,
      languageKm,
      languageZh,
      languageVi,
      localeCountries,
      getCountryByLanguageCode,
      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,
      mqShallShowRightSidebar,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";

.detectLanguage-dropdown .dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}

.sticky-search {
  position: sticky;
  top: 0;
}

.flag {
  font-size: 18px;
}

.translateBox {
  color: #fff;
  padding: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}
</style>
